/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */

import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const CommonMessages = {
  save: () => _t(translations.buttonsNames.save),
  delete: () => _t(translations.buttonsNames.delete),
  cancel: () => _t(translations.buttonsNames.cancel),
  submit: () => _t(translations.buttonsNames.submit),
  view: () => _t(translations.buttonsNames.view),
  addSubmit: () => _t(translations.buttonsNames.addSubmit),
  uploadDocuments: () => _t(translations.buttonsNames.uploadDocuments),
  renewalHistory: () => _t(translations.buttonsNames.renewalHistory),
  addPayment: () => _t(translations.buttonsNames.addPayment),
  modify: () => _t(translations.buttonsNames.modify),
  closeLoan: () => _t(translations.buttonsNames.closeLoan),
  export: () => _t(translations.buttonsNames.export),
  addFacility: () => _t(translations.buttonsNames.addFacility),
  convert: () => _t(translations.buttonsNames.convert),
  clear: () => _t(translations.buttonsNames.clear),
  discard: () => _t(translations.buttonsNames.discard),
  allUnsavedInformation: () =>
    _t(translations.buttonsNames.allUnsavedInformation),
  willBeLostIfYouGoBackAreYouSure: () =>
    _t(translations.buttonsNames.willBeLostIfYouGoBackAreYouSure),
  //SideBar Labels
  facility: () => _t(translations.sideBar.facility),
  loan: () => _t(translations.sideBar.loan),
  loc: () => _t(translations.sideBar.loc),
  rate: () => _t(translations.sideBar.rate),
  user: () => _t(translations.sideBar.user),
  masterData: () => _t(translations.sideBar.masterData),
  logOut: () => _t(translations.sideBar.logOut),
  dashboard: () => _t(translations.sideBar.dashboard),
  dataUpload: () => _t(translations.sideBar.dataUpload),
  // Toast labels
  error: () => _t(translations.customToast.error),
  success: () => _t(translations.customToast.success),
  warning: () => _t(translations.customToast.warning),
  info: () => _t(translations.customToast.info),
  close: () => _t(translations.buttonsNames.close),
  noDataFound: () => _t(translations.buttonsNames.noDataFound),
  //fields
  noOptionsFound: () => _t(translations.fields.noOptionsFound),
  search: () => _t(translations.fields.search),
  logoutButtonLabel: () => _t(translations.buttonsNames.logout),
  mISPortal: () => _t(translations.buttonsNames.mISPortal),
  fixedDeposit: () => _t(translations.buttonsNames.fixedDeposit),
  calculate: () => _t(translations.buttonsNames.calculate),
};
